import React, { useRef } from "react";
import { AiOutlineUpload } from "react-icons/ai";
import { Button } from "./Button";

interface IProps {
  id?: string;
  label?: string;
  required?: boolean;
  className?: string;
  onChange?: (_file?: File) => void;
  value?: File | string;
  preview?: string;
}

export function ImagePicker({ label, required, className = "", id, onChange = () => {}, preview }: IProps) {
  const imageRef = useRef<any>(null);

  return (
    <div className={className}>
      <label className="text-gray-500  text-sm flex-shrink-0" htmlFor={id}>
        {label}
        {required && <span className="text-red-500"> * </span>}
      </label>

      <div
        className="w-full h-[150px] outline-2 border-gray-500 outline-dashed bg-slate-100 overflow-hidden group bg-cover bg-no-repeat bg-center "
        style={{
          backgroundImage: `url(${preview})`,
        }}
      >
        {preview ? (
          <div className="flex items-end h-full justify-between w-full bg-slate-800 bg-opacity-40 transition-all translate-y-full group-hover:translate-y-0">
            <Button
              text="Change"
              className="bg-lime-500 w-full rounded-none text-sm"
              onClick={() => {
                imageRef.current?.click();
              }}
            />
            <Button
              text="Remove"
              className="bg-rose-500 w-full rounded-none text-sm"
              onClick={() => {
                if (onChange) {
                  onChange();
                }
              }}
            />
          </div>
        ) : (
          <Button
            text={<AiOutlineUpload size={50} />}
            className="cursor-pointer text-slate-400 w-full h-full flex items-center justify-center "
            onClick={() => {
              imageRef.current?.click();
            }}
          ></Button>
        )}

        <input
          ref={imageRef}
          type="file"
          className="hidden"
          onChange={(e) => {
            if (onChange && e.target.files) {
              onChange(e.target.files[0]);
            }
          }}
        />
      </div>
    </div>
  );
}
